<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M24 35a9 9 0 119-9 9 9 0 01-9 9zm0-15a6 6 0 106 6 6 6 0 00-6-6z"/><circle cx="12" cy="19" r="2"/><path d="M30.76 10l2.53 2.54A5 5 0 0036.83 14H41v24H7V14h4.17a5 5 0 003.54-1.46L17.24 10h13.52m.41-3H16.83a2 2 0 00-1.42.59l-2.82 2.82a2 2 0 01-1.42.59H6a2 2 0 00-2 2v26a2 2 0 002 2h36a2 2 0 002-2V13a2 2 0 00-2-2h-5.17a2 2 0 01-1.42-.59l-2.82-2.82A2 2 0 0031.17 7z"/></svg>